import React from "react";

import SiteContainer from "src/components/siteContainer/siteContainer";
import { ModuleHeadV2 } from "src/components/moduleHead/moduleHead.v2";

import Link from "src/components/link";
import ImageV2 from "src/components/image/image.v2";
import { CTAButtonV2 } from "src/components/ctabutton";

import { getLanguageField } from "src/utils/language";
import BackgroundImageWrapper from "src/components/backgroundImageWrapper/backgroundImageWrapper";
import { ModuleWrapperV2 } from "src/components/moduleWrapper/moduleWrapper.v2";


class WrapWithLink extends React.Component<{link?: string | undefined; label?: string | undefined; children: React.ReactNode; }> {
  render() {
    const {link, label, children} = this.props;
    if (!link) return children;
    if (link === "#") return children;
    return <>
      <Link href={link} title={label} className="inline-flex items-center justify-center border border-transparent text-base font-medium rounded-md buttonText">
        {children}
      </Link>
    </>
  }
}

export default class FullImage extends React.Component<ModuleProps<FullImageModuleData>> {
  get paddings() {
    return { top: this.props.data?.item?.padding_top, bottom: this.props.data?.item?.padding_bottom };
  }

  get hasCTA(): boolean {
    if (this.props.data.item.cta_button_1) return true;
    if (this.props.data.item.cta_button_2) return true;
    if (this.props.data.item.cta_button_3) return true;
    return false;
  }

  private translate(key: string): string | undefined {
    const item = this.props.data.item;
    const lang = this.props.data.selectedLanguage;
    return getLanguageField(item.translations, lang, key) as string | undefined;
  }

  get title() { return this.translate('title'); }
  get subtitle() { return this.translate('subtitle'); }
  get ctaLabel() { return this.translate('label'); }
  get ctaLink() { return this.translate('href'); }
  get anchor() { return this.translate('anchor'); }

  get innerPaddings() {
    if (this.props.data.item.width === 'full_screen') return "px-6 xl:px-0";
    return "px-4 sm:px-6 lg:px-8 py-8";
  }

  get outterMargin() {
    if (this.props.data.item.width === 'full_screen') return "";
    return "mx-4 sm:mx-6 xl:mx-0 my-8 lg:my-12";
  }

  get flexAlignment() {
    if (this.props.data.item.alignment === "text-left") return "items-start";
    if (this.props.data.item.alignment === "text-center") return "items-center";
    return "items-end";
  }

  get isFullWidth() {
    return this.props.data.item?.width === "full_screen";
  }

  get backgroundColor(){
    return this.props.data.item?.background_color?.value || "transparent"
  }

  get boxedBackgroundColor(){
    const { boxed_background_color } = this.props.data.item;
    if (!this.isFullWidth) return boxed_background_color?.value || "transparent";
    return "";
  }

  get image(){
    const desktopImage = this.props.data.item.image?.imageFile;
    const mobileImage = this.props.data.item.mobile_image?.imageFile;

    return{
      desktopImage: desktopImage || mobileImage,
      mobileImage: mobileImage || desktopImage
    }
  }

  get imageAlt(){
    const desktopImageTitle = this.props.data.item.image?.title;
    const mobileImageTitle = this.props.data.item.mobile_image?.title;
    const moduleTitle = this.title;

    return{
      desktopAlt: desktopImageTitle || mobileImageTitle || moduleTitle || "",
      mobileAlt: mobileImageTitle || desktopImageTitle || moduleTitle || ""
    }
  }

  render() {
    const item = this.props.data.item;
    const lang = this.props.data.selectedLanguage;
    const deflang = this.props.data.defaultLanguage;

    return <BackgroundImageWrapper backgroundColor={this.backgroundColor}>
      <SiteContainer fullwidth={item.width === 'full_screen'}>
        <ModuleWrapperV2
          anchor={this.anchor}
          name={item.name}
          roundedCorners={item.rounded_corners}
          className={`relative ${this.innerPaddings} ${this.outterMargin}`}
          backgroundColor={this.boxedBackgroundColor}
          isFullWidth={this.isFullWidth}
          paddings={this.paddings}>

            <div className="max-w-7xl mx-auto">

              <ModuleHeadV2
                title={this.title}
                subtitle={this.subtitle}
                description={undefined}
                color_title={item.title_color?.value}
                color_subtitle={item.subtitle_color?.value}
                alignment={item.alignment}
                align_lists
              />

              <div className={item.alignment}>
                <div className={`mx-auto text-md sm:text-lg`}>
                  <WrapWithLink label={this.ctaLabel} link={this.ctaLink}>
                    <ImageV2 className="w-full hidden sm:flex" src={this.image.desktopImage} alt={this.imageAlt.desktopAlt} />
                    <ImageV2 className="w-full sm:hidden" src={this.image.mobileImage} alt={this.imageAlt.mobileAlt} />
                  </WrapWithLink>
                </div>

                {
                  this.hasCTA
                  ?
                  <div className="mt-8">
                    <div className={`inline-flex gap-4 ${this.flexAlignment}`}>
                      {item.cta_button_1 ? <CTAButtonV2 language={lang} defaultLanguage={deflang} ctabutton={item.cta_button_1} /> : null }
                      {item.cta_button_2 ? <CTAButtonV2 language={lang} defaultLanguage={deflang} ctabutton={item.cta_button_2} /> : null }
                      {item.cta_button_3 ? <CTAButtonV2 language={lang} defaultLanguage={deflang} ctabutton={item.cta_button_3} /> : null }
                    </div>
                  </div>
                  : null
                }
              </div>
            </div>
          </ModuleWrapperV2>
        </SiteContainer>
      </BackgroundImageWrapper>
    }
}